import { cva as s } from "@scalar/use-hooks/useBindCx";
import { styles as a } from "../ScalarButton/variants.js";
const o = s({
  base: "scalar-icon-button grid aspect-square cursor-pointer rounded",
  variants: {
    size: {
      xxs: "size-3.5 p-0.5",
      xs: "size-5 p-1",
      sm: "size-6 p-1",
      md: "size-10 p-3",
      full: "size-full"
    },
    disabled: {
      true: "cursor-not-allowed shadow-none"
    },
    variant: a
  },
  compoundVariants: [
    {
      size: "md",
      variant: "ghost",
      class: "size-8 p-2 m-1 -outline-offset-2 rounded-lg"
    }
  ],
  defaultVariants: {
    size: "md",
    variant: "ghost"
  }
});
export {
  o as variants
};
